import styles from './line.module.css';

export const LoaderLine = () => {
  return (
    <div className={styles.root}>
      <div className={styles.bar} />
    </div>
  );
};
